module.exports = __webpack_public_path__ + "static/media/circle_interiors.1de9bdac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circle_interiors.jpg
// module id = 204
// module chunks = 0